import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import Particles from "particles.vue3"
import "@/util/axios.config"
import zhCn from 'element-plus/es/locale/lang/zh-cn'

createApp(App)
    .use(Particles)
    .use(ElementPlus, { locale: zhCn })
    .use(router)
    .use(store)
    .mount('#app')
